import { Dialog } from "@/features/calendar/components/dialog.tsx";
import { useHelpPopupStore } from "@/features/help/store/useHelpPopupStore.tsx";

export const HelpPopup = () => {
  const { isOpen, setIsOpen, content } = useHelpPopupStore();

  return (
    <>
      <Dialog open={isOpen} onOpenChange={() => setIsOpen(false)}>
        {content}
      </Dialog>
    </>
  );
};
